import { render, staticRenderFns } from "./SonicBoomViz.vue?vue&type=template&id=8660b66c&scoped=true"
import script from "./SonicBoomViz.vue?vue&type=script&lang=js"
export * from "./SonicBoomViz.vue?vue&type=script&lang=js"
import style0 from "./SonicBoomViz.vue?vue&type=style&index=0&id=8660b66c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8660b66c",
  null
  
)

export default component.exports